import { createSlice } from '@reduxjs/toolkit';
import { logout } from "../common/reducers/initContext";
import { dataHookFactory } from '../common/reducers/utilities';
import { inside } from '../common/utils/geoUtilities';
import { ensureArray } from '../common/utils/arrayUtilities';

export const compareCrewFilters = (f1, f2) => f1.type === f2.type && f1.kind === f2.kind;

export const crewFilterSlice = createSlice({
    name: 'crewFilter',
    initialState: {
        filters: [],
    },
    reducers: {
        set: (state, action) => {
            state.filters = action.payload
        },
        addOrUpdate: (state, action) => {
            for (const filter of ensureArray(action.payload)) {
                let idx = state.filters.findIndex(f => f.type === filter.type && f.kind === filter.kind);
                if (idx >= 0) {
                    state.filters.splice(idx, 1, filter);
                } else {
                    state.filters.push(filter);
                }
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => crewFilterSlice.getInitialState());
    }
});

// #region network operations
export const fetchCrewFilters = network => network.get('/api/v1/crewFilter', crewFilterSlice.actions.set);
export const insertCrewFilter = (network, filter) => {
    network.put(`/api/v1/crewFilter/${encodeURIComponent(filter.type)}/${encodeURIComponent(filter.kind)}`, {}, crewFilterSlice.actions.addOrUpdate);
};
export const removeCrewFilter = (network, filter) => {
    network.delete(`/api/v1/crewFilter/${encodeURIComponent(filter.type)}/${encodeURIComponent(filter.kind)}`, crewFilterSlice.actions.addOrUpdate);
};
// #endregion

// #region selectors
const selectCrewFilters = state => state.crewFilter.filters;
// #endregion

// #region listeners
// #endregion

// #region utilities
const matchesZone = (filters, data) => {
    const activeZoneFilters = filters.filter(f => f.kind === 'Zone' && f.selected);
    if (activeZoneFilters.length === 0 || data.longitude === null || data.longitude === undefined || data.latitude === null || data.latitude === undefined) {
        return true;
    }
    return activeZoneFilters.some(f => inside([data.longitude, data.latitude], f.definition))
}
const matchesSite = (filters, data) => data.site === null || data.site === undefined || filters.length === 0 || filters.some(f => f.kind === 'Site' && f.type === data.site && !f.selected);
const matchesLevel = (filters, data) => data.level === null || data.level === undefined || filters.length === 0 || filters.some(f => f.kind === 'Level' && f.type === data.level && !f.selected);
const matchesType = (filters, data) => data.type === null || data.type === undefined || filters.length === 0 || filters.some(f => f.kind === 'Type' && f.type === data.type && !f.selected);
const matchesKind = (filters, data) => data.kind === null || data.kind === undefined || filters.length === 0 || filters.some(f => f.kind === 'Kind' && f.type === data.kind && !f.selected);
export const matches = (filters, data) => matchesType(filters, data) && matchesLevel(filters, data) && matchesSite(filters, data) && matchesZone(filters, data) && matchesKind(filters, data);
export const active = filters => filters.some(f => f.selected);
// #endregion

export const [useCrewFilters] = dataHookFactory(selectCrewFilters, { run: fetchCrewFilters });

const reducerDetails = { name: crewFilterSlice.name, reducer: crewFilterSlice.reducer };
export default reducerDetails;